<template>
  <div class="DateSelect">
    <el-radio-group v-model="active" @input="radioChange">
      <el-radio-button
        v-for="(item, index) in list"
        :key="index"
        :class="{ date_radio: true, date_radio_custom: item.type === 'daterange' }"
        :label="item.value"
        :disabled="item.value === 'custom'">
        <span v-if="item.type === 'text'">{{ item.label }}</span>
        <el-date-picker
          v-if="item.type === 'daterange'"
          class="date_radio_daterange"
          v-model="item.dates"
          type="daterange"
          :clearable="false"
          value-format="yyyy-MM-dd"
          :picker-options="customPickerOptions"
          @focus="customPickerFocus"
          @change="customPickerChange">
        </el-date-picker>
      </el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
  export default {
    name: 'DateSelect',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {
        active: '',
        list: [
          {
            type: 'text',
            label: '今天',
            value: 'today',
            dates: []
          },
          {
            type: 'text',
            label: '明天',
            value: 'tomorrow',
            dates: []
          },
          {
            type: 'text',
            label: '后天',
            value: 'afterTomorrow',
            dates: []
          },
          {
            type: 'text',
            label: '昨天',
            value: 'yesterday',
            dates: []
          },
          {
            type: 'text',
            label: '本周',
            value: 'thisWeek',
            dates: []
          },
          {
            type: 'text',
            label: '本月',
            value: 'thisMonth',
            dates: []
          },
          {
            type: 'text',
            label: '上月',
            value: 'lastMonth',
            dates: []
          },
          {
            type: 'daterange',
            label: '',
            value: 'custom',
            dates: []
          }
        ],
        customPickerMap: {
          firstSelectedDate: null
        }
      }
    },
    computed: {
      customPickerOptions () {
        return {
          disabledDate: (date) => {
            if (!this.customPickerMap.firstSelectedDate) {
              return false
            }

            const startDate = new Date(this.customPickerMap.firstSelectedDate)
            const minDate = new Date(startDate)
            minDate.setDate(minDate.getDate() - 30)
            
            const maxDate = new Date(startDate)
            maxDate.setDate(maxDate.getDate() + 30)
            
            return date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()
          },
          onPick: ({ maxDate, minDate }) => {
            if (!maxDate && minDate) {
              this.customPickerMap.firstSelectedDate = minDate
            } else {
              this.customPickerMap.firstSelectedDate = null
            }
          }
        }
      }
    },
    created () {
      this.initDate()
    },
    methods: {
      initDate () {
        this.list.map(v => {
          const nowDate = new Date()
          switch (v.value) {
            case 'today':
              const today = new Date(nowDate).Format('yyyy-MM-dd')
              v.dates = [today, today]
              break
            case 'tomorrow':
              let tomorrowDay = new Date(nowDate)
              tomorrowDay.setDate(tomorrowDay.getDate() + 1)
              tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
              v.dates = [tomorrowDay, tomorrowDay]
              break
            case 'afterTomorrow':
              let afterTomorrowDay = new Date(nowDate)
              afterTomorrowDay.setDate(afterTomorrowDay.getDate() + 2)
              afterTomorrowDay = afterTomorrowDay.Format('yyyy-MM-dd')
              v.dates = [afterTomorrowDay, afterTomorrowDay]
              break
            case 'yesterday':
              let yesterdayDay = new Date(nowDate)
              yesterdayDay.setDate(yesterdayDay.getDate() - 1)
              yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
              v.dates = [yesterdayDay, yesterdayDay]
              break
            case 'thisWeek':
              const nowDayWeek = nowDate.getDay() !== 0 ? nowDate.getDay() : 7
              
              let thisWeekStartDay = new Date(nowDate)
              thisWeekStartDay.setDate(thisWeekStartDay.getDate() - (nowDayWeek - 1))
              thisWeekStartDay = thisWeekStartDay.Format('yyyy-MM-dd')
              
              let thisWeekEndDay = new Date(nowDate)
              thisWeekEndDay.setDate(thisWeekEndDay.getDate() + (7 - nowDayWeek))
              thisWeekEndDay = thisWeekEndDay.Format('yyyy-MM-dd')

              v.dates = [thisWeekStartDay, thisWeekEndDay]
              break
            case 'thisMonth':
              let thisMonthStartDay = new Date(nowDate)
              thisMonthStartDay.setDate(1)
              thisMonthStartDay = thisMonthStartDay.Format('yyyy-MM-dd')
              
              let thisMonthEndDay = new Date(nowDate)
              thisMonthEndDay.setDate(1)
              thisMonthEndDay.setDate(32)
              thisMonthEndDay.setDate(0)
              thisMonthEndDay = thisMonthEndDay.Format('yyyy-MM-dd')
              
              v.dates = [thisMonthStartDay, thisMonthEndDay]
              break
            case 'lastMonth':
              let lastMonthStartDay = new Date(nowDate)
              lastMonthStartDay.setDate(0)
              lastMonthStartDay.setDate(1)
              lastMonthStartDay = lastMonthStartDay.Format('yyyy-MM-dd')
              
              let lastMonthEndDay = new Date(nowDate)
              lastMonthEndDay.setDate(0)
              lastMonthEndDay = lastMonthEndDay.Format('yyyy-MM-dd')
              
              v.dates = [lastMonthStartDay, lastMonthEndDay]
              break
            case 'daterange':
              v.dates = []
              break
          }
        })
        const hasDay = this.list.find(v => {
          return v.value !== 'custom' && (JSON.stringify(v.dates) === JSON.stringify(this.value))
        })
        if (hasDay) {
          this.active = hasDay.value
        }
      },
      radioChange () {
        if (this.active !== 'custom') {
          const info = this.list.find(v => { return v.value === this.active })
          this.$emit('change', JSON.parse(JSON.stringify(info.dates)))
        }
      },
      customPickerFocus () {
        const info = this.list.find(v => { return v.value === 'custom' })
        info.dates = JSON.parse(JSON.stringify(this.value))
      },
      customPickerChange (date) {
        this.$emit('change', JSON.parse(JSON.stringify(date)))
      }
    },
    watch: {
      value () {
        const hasDay = this.list.find(v => {
          return v.value !== 'custom' && (JSON.stringify(v.dates) === JSON.stringify(this.value))
        })
        if (hasDay) {
          this.active = hasDay.value
        } else {
          this.active = 'custom'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .DateSelect {
    width: 100%;
  }

  .date_radio /deep/ .el-radio-button__inner {
    padding: 0 16px;
    height: 36px;
    line-height: 34px;
    cursor: pointer;
  }

  .date_radio.is-active /deep/ .el-radio-button__inner {
    color: #1890FF;
    background-color: #FFFFFF;
    border-color: #1890FF;
    box-shadow: -1px 0 0 0 #1890ff;
  }

  .date_radio_custom /deep/ .el-radio-button__inner {
    padding: 0 0 0 0;
    font-size: 0px;
  }

  .date_radio_daterange {
    padding: 0 10px;
    width: fit-content;
    height: 100%;
    border: none;
  }

  .date_radio_daterange /deep/ .el-range__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 0;
  }

  .date_radio_daterange /deep/ .el-range-input {
    display: none;
  }

  .date_radio_daterange /deep/ .el-range-separator {
    display: none;
  }

  .date_radio_daterange /deep/ .el-range__close-icon {
    display: none;
  }
</style>